import React, { FC, useState } from 'react';
import { ChevronIcon } from '@dynamika-shared/ui/icons/Chevron';
import { Dropdown } from '@dynamika-shared/ui/Dropdown/Dropdown';
import { Modal } from '@dynamika-shared/ui/Modal/Modal';
import { useLogout } from '@hooks/useLogout';
import { AuthUser } from '@dynamika-shared/types/auth';
import { Avatar } from '@components/Avatar/Avatar';
import { UserMenuPopup } from './UserMenu.popup';
import { TruncatedText } from '@dynamika-shared/ui/TruncatedText/TruncatedText';

type UserMenuViewProps = {
  authUser?: AuthUser;
  useAttributes?: boolean;
};

export const UserMenuView: FC<UserMenuViewProps> = ({
  authUser,
  useAttributes,
}) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const { logout } = useLogout();
  const [visible, setVisible] = useState(false);

  const userName =
    authUser?.name && (authUser?.given_name || authUser?.family_name)
      ? `${authUser?.name} ${authUser?.family_name ?? authUser?.given_name}`
      : authUser?.nickname;

  const dropdownRender = () => {
    return (
      <div onClick={() => setVisible(!visible)}>
        <UserMenuPopup
          authUser={authUser}
          setShowModal={setShowModal}
          userName={userName}
        />
      </div>
    );
  };

  return (
    <div data-testid='UserMenu' className='cursor-pointer'>
      <Dropdown
        rootClassName='!min-w-[35rem]'
        dropdownRender={dropdownRender}
        open={visible}
        onOpenChange={(_, { source }) => {
          if (source === 'trigger') setVisible(!visible);
        }}
        trigger={['click']}
      >
        <div className='flex items-center'>
          <Avatar userName={userName ?? ''} nameSeparator={' '} />
          {useAttributes && (
            <div className='mx-1.5 flex flex-col'>
              <TruncatedText
                text={userName}
                truncate
                tooltip
                className={'text-[16px] font-semibold text-black max-w-[15rem]'}
              />

              <TruncatedText
                text={authUser?.email}
                truncate
                tooltip
                className={'text-1216 text-black max-w-[15rem]'}
              />
            </div>
          )}
          <ChevronIcon className='ml-0.5 h-2 w-2' dir='down' />
        </div>
      </Dropdown>
      <Modal
        width={440}
        onCancel={async () => {
          setShowModal(false);
        }}
        onOk={() => {
          logout();
        }}
        okText='Yes, Log Out'
        cancelText='No, Cancel'
        open={showModal}
        classNames={{
          header: '!mb-8 mt-3',
          content: 'text-center !rounded-[2.4rem] !p-[4rem]',
          footer: 'flex justify-between !mt-3',
        }}
        title={
          <div>
            <p className='text-[2.4rem] leading-[3.2rem]'>
              Are you sure you want
            </p>
            <p className='text-[2.4rem] leading-[3.2rem]'>to log out?</p>
          </div>
        }
      />
    </div>
  );
};
